import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import Router from './router';
import { AuthProvider } from './context';
import { setMomentLocale } from './utils';
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react';

function App() {

  const toastStyles = {
    padding: 12,
    color: '#3F3F46',
  }

  useEffect(() => {
    setMomentLocale();
  }, []);

  return (
    <Provider store={store}>
      <AuthProvider>
        <PersistGate loading={null} persistor={persistor}>
          <Router />
          <Toaster position="bottom-center" toastOptions={{ style: toastStyles }} />
        </PersistGate>
      </AuthProvider>
    </Provider>
  );
}

export default App;
